import { postMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const CREATE_QUESTIONNAIRE = 'CREATE_QUESTIONNAIRE';
export const CREATE_QUESTIONNAIRE_SUCCESS = 'CREATE_QUESTIONNAIRE_SUCCESS';
export const CREATE_QUESTIONNAIRE_FAILURE = 'CREATE_QUESTIONNAIRE_FAILURE';

// Action Creators
export const getCreateQuestionnaireRequest = () => ({
  type: CREATE_QUESTIONNAIRE,
});

export const getCreateQuestionnaireSuccess = (users) => ({
  type: CREATE_QUESTIONNAIRE_SUCCESS,
  payload: users,
});

export const getCreateQuestionnaireFailure = (error) => ({
  type: CREATE_QUESTIONNAIRE_FAILURE,
  payload: error,
});

// Thunk Function
export const postQuestionnaireRequest = (external, body) => {
  return async (dispatch) => {
    dispatch(getCreateQuestionnaireRequest());
    try {
      const response = await postMethodWithToken(url.createQuestionnaire, body);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getCreateQuestionnaireSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(getCreateQuestionnaireFailure('error?.message'));
      }
    } catch (error) {
      dispatch(getCreateQuestionnaireFailure(error?.message));
    }
  };
};
